import {Button, Card, Divider, Text} from '@nextui-org/react';
import React, {useState} from 'react';
import {QuotesIcon} from '../Icons/QuotesIcon';
import {Flex} from '../styles/flex';
import ModalQRCode from "../ModalQRCode";

export const Testimonials = () => {
    const [visible, setVisible] = useState(false)
    const changeModal = () =>{
        setVisible(!visible)
    }
   return (
      <>
          <ModalQRCode type="SERVICE_MINI" changeModal={changeModal} initVisible={visible}></ModalQRCode>
         <Flex
            direction={'column'}
            css={{
               'gap': '1rem',
               'justifyContent': 'center',
               'alignItems': 'center',
               'px': '$6',
               'py': '$20',
               'flexDirection': 'column-reverse',
               '@sm': {
                  justifyContent: 'space-around',
                  px: '$32',
                  flexDirection: 'row-reverse',
               },
               '@md': {
                  px: '$64',
               },
            }}
         >
            <Flex direction="column" css={{gap: '1.5rem'}}>
               <Card>
                  <Card.Body>
                     <Flex
                        css={{
                           py: '$10',
                           gap: '$5',
                        }}
                     >
                        <QuotesIcon />
                        <Flex direction={'column'} css={{gap: '0.5rem'}}>
                           <Text
                              span
                              css={{
                                 maxWidth: '400px',
                                 color: '$accents8',
                              }}
                           >
                               开发周期至少需要3个月，小程序10天左右即可，更能适应网络发展趋势。
                           </Text>
                           <Text
                              span
                              weight={'bold'}
                              css={{
                                 maxWidth: '400px',
                                 display: 'contents',
                                 color: '$accents9',
                              }}
                           >
                               开发周期短{' '}
                           </Text>
                           <Text
                              span
                              css={{
                                 display: 'contents',
                                 color: '$accents8',
                              }}
                           >
                              {/*- CEO at Company*/}
                           </Text>
                        </Flex>
                     </Flex>
                  </Card.Body>
               </Card>

               <Card>
                  <Card.Body>
                     <Flex
                        css={{
                           py: '$10',
                           gap: '$5',
                        }}
                     >
                        <QuotesIcon />
                        <Flex direction={'column'} css={{gap: '0.5rem'}}>
                           <Text
                              span
                              css={{
                                 maxWidth: '400px',
                                 color: '$accents8',
                              }}
                           >
                               小程序基于微信开发环境以及流量人群，开发成本、推广成本远远低于APP。
                           </Text>
                           <Text
                              span
                              weight={'bold'}
                              css={{
                                 maxWidth: '400px',
                                 display: 'contents',
                                 color: '$accents9',
                              }}
                           >
                               开发成本低{' '}
                           </Text>
                           <Text
                              span
                              css={{
                                 display: 'contents',
                                 color: '$accents8',
                              }}
                           >
                              {/*- CEO at Company*/}
                           </Text>
                        </Flex>
                     </Flex>
                  </Card.Body>
               </Card>

               <Card>
                  <Card.Body>
                     <Flex
                        css={{
                           py: '$10',
                           gap: '$5',
                        }}
                     >
                        <QuotesIcon />
                        <Flex direction={'column'} css={{gap: '0.5rem'}}>
                           <Text
                              span
                              css={{
                                 maxWidth: '400px',
                                 color: '$accents8',
                              }}
                           >
                               微信小程序不需要考虑兼容性稳定性、安全性等问题
                           </Text>
                           <Text
                              span
                              weight={'bold'}
                              css={{
                                 maxWidth: '400px',
                                 display: 'contents',
                                 color: '$accents9',
                              }}
                           >
                               用户体验好{' '}
                           </Text>
                           <Text
                              span
                              css={{
                                 display: 'contents',
                                 color: '$accents8',
                              }}
                           >

                           </Text>
                        </Flex>
                     </Flex>
                  </Card.Body>
               </Card>
            </Flex>
            <Flex
               align={'start'}
               direction={'column'}
               css={{
                  'alignItems': 'center',
                  '@sm': {
                     alignItems: 'start',
                  },
               }}
            >
               <Text span css={{color: '$blue600'}}>
                   小程序
               </Text>
               <Text h3>操作更简单</Text>
               <Text span css={{color: '$accents8', maxW: '600px', pb: '$8'}}>
                  解决企业开发成本高，周期长的难题
                   无需下载，使用方便，使用场景更丰富，操作实用性更强。
               </Text>
               <Button onClick={changeModal}>马上拥有</Button>
            </Flex>
         </Flex>

         {/*<Divider*/}
         {/*   css={{position: 'absolute', inset: '0p', left: '0', mt: '$5'}}*/}
         {/*/>*/}
      </>
   );
};
